import isEqual from 'lodash-es/isEqual';
import pick from 'lodash-es/pick';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import createSavedSearch from 'ha/modules/SavedSearches/actions/createSavedSearch';

import { getSearchParams, getPreviousParams } from '../selectors';
import { getKindsFromCategories } from '../utils';

const queryParams = [
  'citySearch',
  'priceMin',
  'priceMax',
  'categories',
  'startDate',
  'endDate',
  'types',
  'currency',
];

const shouldSaveSearch = (currentParams, previousParams) =>
  !isEqual(pick(previousParams, queryParams), pick(currentParams, queryParams));

const normalizeSearchParams = ({
  citySearch,
  priceMin,
  priceMax,
  categories,
  startDate,
  endDate,
  currency,
}) => {
  const [city, country] = citySearch.split('--');

  const kinds = getKindsFromCategories(categories);

  return {
    minPrice: priceMin,
    maxPrice: priceMax,

    kinds,
    city,
    country,
    startDate,
    endDate,
    currency,
  };
};

export default () => (dispatch, getState) => {
  const state = getState();

  const searchParams = getSearchParams(state);
  const previousParams = getPreviousParams(state);
  const userId = getUserId(state);

  if (userId && shouldSaveSearch(searchParams, previousParams)) {
    const normalizedSearchParams = normalizeSearchParams(searchParams);

    return dispatch(createSavedSearch(normalizedSearchParams, userId));
  }

  return Promise.resolve();
};
